var render = function () {
  var _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "location-picker"
  }, [_vm.loadingState ? _c('div', {
    staticClass: "z-40 overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full overlay-t-modal-custom fixed bg-opacity-50 bg-black"
  }, [_c('div', {
    staticClass: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center"
  }, [_c('svg', {
    staticClass: "h-24 w-24 animate-spin text-blue-600 mb-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 2 A 10 10 0 0 1 22 12",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])])]) : _vm._e(), _c('t-modal-open-map', {
    ref: "openModalMap",
    staticClass: "w-1/2",
    on: {
      "closed": _vm.handleCloseMap
    }
  }, [_c('div', {
    staticClass: "w-full mx-auto p-0 bg-white rounded-lg"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', [_c('h2', {
    staticClass: "text-xl font-bold mb-0"
  }, [_vm._v("Add New Location")])]), _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.closeMoap
    }
  }, [_c('i', {
    staticClass: "fa fa-times text-gray-500 text-lg font-light",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm.permission_location ? _c('div', {
    staticClass: "bg-orange-50 p-3 rounded-lg my-4"
  }, [_c('h2', {
    staticClass: "text-base font-semibold mb-0 text-yellow-600"
  }, [_vm._v("Location Access Not Active")]), _c('p', {
    staticClass: "text-sm text-yellow-600 m-0"
  }, [_vm._v("To use the Read on Site feature, enable location permissions in your browser.")])]) : _vm._e(), _c('div', {
    staticClass: "flex justify-between items-start w-full my-4"
  }, [_c('div', {
    staticClass: "flex w-auto items-center justify-start"
  }, [_c('span', {
    staticClass: "text-blue-600"
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Find Access Location")]), _c('div', {
    staticClass: "h-0.5 w-20 bg-blue-500 ml-3"
  })]), _c('div', {
    staticClass: "flex w-auto items-center justify-start"
  }, [_c('span', {
    class: {
      'text-blue-600': _vm.showMap,
      'text-gray-500 opacity-50': !_vm.showMap
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Set Coordinate Point")]), _c('div', {
    staticClass: "h-0.5 w-20 ml-3",
    class: {
      'bg-blue-500': _vm.confirmLocation,
      'bg-gray-500 opacity-50': !_vm.confirmLocation
    }
  })]), _c('div', {
    staticClass: "flex w-auto items-center justify-start"
  }, [_c('span', {
    class: {
      'text-blue-600': _vm.confirmLocation,
      'text-gray-500 opacity-50': !_vm.confirmLocation
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Define Access Radius")])])]), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "position": "relative",
      "z-index": "9999"
    }
  }, [!_vm.showMap ? _c('label', {
    staticClass: "text-base font-medium"
  }, [_vm._v("Access Point or Location")]) : _vm._e(), !_vm.showMap ? _c('div', {
    staticClass: "relative"
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-4"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchQuery,
      expression: "searchQuery"
    }],
    staticClass: "custom-search-input rounded-xl pl-10 text-sm py-2.5 border w-full",
    class: {
      'bg-gray-50': this.permission_location,
      'bg-white': !this.permission_location
    },
    attrs: {
      "disabled": this.permission_location,
      "type": "text",
      "placeholder": "Search by location name, street, building, or latitude & longitude"
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value;
      }, _vm.searchLocationsMap]
    }
  }), _vm.isLocationSearch ? _c('small', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("Mencari lokasi...")]) : _vm._e(), !_vm.permission_location ? _c('div', {
    staticClass: "form-group mt-4 w-full"
  }, [_c('div', {
    staticClass: "bg-white border rounded-xl w-full overflow-hidden"
  }, [_c('div', {
    staticClass: "flex items-center px-3 text-gray-700 cursor-pointer hover:bg-gray-50",
    class: _vm.searchResults && _vm.searchResults.length > 0 ? 'py-3' : 'py-2.5',
    on: {
      "click": _vm.getCurrentLocation
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-location-crosshairs text-lg mr-3 text-gray-400"
  }), _c('span', {
    staticClass: "text-sm text-gray-700"
  }, [_vm._v("Use current location")])]), _vm.searchResults && _vm.searchResults.length > 0 ? _c('ul', {
    staticClass: "bg-white border-t max-h-72 overflow-y-auto"
  }, _vm._l(_vm.searchResults, function (result, index) {
    return _c('li', {
      key: ((result.place_id) + "-" + index),
      staticClass: "flex items-start px-3 py-2.5 cursor-pointer hover:bg-gray-50 transition-colors",
      on: {
        "click": function ($event) {
          return _vm.onLocationSelected(result);
        }
      }
    }, [_c('div', {
      staticClass: "mt-0.5 shrink-0"
    }, [_c('img', {
      staticClass: "w-4 h-4 mr-3 opacity-80",
      attrs: {
        "src": require('@/assets/img/pinlocation.svg'),
        "alt": "pin"
      }
    })]), _c('div', {
      staticClass: "flex flex-col"
    }, [_c('div', {
      staticClass: "text-sm font-medium text-gray-900 tracking-wide"
    }, [_vm._v(_vm._s(result.name))]), _c('div', {
      staticClass: "text-xs font-normal text-gray-500 mt-1 leading-snug pr-2"
    }, [_vm._v(" " + _vm._s(result.display_name) + " ")])])]);
  }), 0) : _vm._e(), _vm.stateEmpty && _vm.searchQuery && _vm.searchResults && _vm.searchResults.length === 0 ? _c('div', {
    staticClass: "border-t text-center"
  }, [_c('div', {
    staticClass: "flex justify-center my-3 flex-col"
  }, [_c('p', {
    staticClass: "m-0 text-sm font-bold leading-5"
  }, [_vm._v("Location \"" + _vm._s(_vm.searchQuery) + "\" Not Found")]), _c('p', {
    staticClass: "m-0 text-xs text-gray-500 leading-5"
  }, [_vm._v(" Try using your current location or type another address in the search box. ")])])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm.showMap && !_vm.confirmLocation ? _c('div', {
    staticClass: "flex-col border p-3 rounded-lg"
  }, [_c('div', {
    staticClass: "flex justify-start items-center space-x-4"
  }, [_c('div', [_c('i', {
    staticClass: "fa-solid fa-location-dot mr-1 text-xl"
  })]), _c('div', {
    staticClass: "flex-col"
  }, [_c('div', [_c('p', {
    staticClass: "text-xs text-gray-500 m-0"
  }, [_vm._v("Address Input")])]), _c('div', {
    staticClass: "font-medium text-sm leading-5"
  }, [_vm._v(_vm._s(this.name))]), _c('div', {
    staticClass: "text-xs font-normal text-gray-500 leading-4"
  }, [_vm._v(" " + _vm._s(this.searchQuery) + " ")])])])]) : _vm._e()]), _vm.showMap && !_vm.confirmLocation ? _c('label', {
    staticClass: "text-base font-medium"
  }, [_vm._v("Pin Point")]) : _vm._e(), _vm.showMap && _vm.confirmLocation ? _c('label', {
    staticClass: "text-base font-medium"
  }, [_vm._v("Set the range/radius from the location point.")]) : _vm._e(), _vm.showMap ? _c('div', {
    staticClass: "map-container relative rounded-xl overflow-hidden mt-0",
    staticStyle: {
      "height": "450px",
      "width": "100%",
      "margin-top": "20px",
      "border": "1px solid #ddd"
    }
  }, [_c('l-map', {
    ref: "myMap",
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "z-index": "1"
    },
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center
    }
  }, [_c('l-tile-layer', {
    attrs: {
      "url": _vm.url,
      "attribution": _vm.attribution
    }
  }), _c('l-circle', {
    attrs: {
      "lat-lng": _vm.markerPosition,
      "radius": Number(_vm.radius) || 0,
      "color": "#3388ff",
      "fill-color": "#3388ff",
      "fill-opacity": 0.2
    }
  }), _c('l-marker', {
    attrs: {
      "lat-lng": _vm.markerPosition,
      "draggable": _vm.lockLocation ? false : true
    },
    on: {
      "dragend": _vm.onMarkerDragEnd
    }
  })], 1), _vm.showMap && _vm.confirmLocation ? _c('div', {
    staticClass: "absolute bottom-0 left-0 z-50 w-full bg-white h-20 shadow-lg flex justify-center items-center"
  }, [_c('div', {
    staticClass: "flex items-center space-x-4 px-4 w-full"
  }, [_c('div', {
    staticClass: "shrink-0"
  }, [_c('img', {
    staticClass: "w-6 h-6",
    attrs: {
      "src": require('@/assets/img/pinlocation.svg'),
      "alt": "pin"
    }
  })]), _c('div', {
    staticClass: "flex flex-col text-left"
  }, [_c('div', {
    staticClass: "font-medium text-sm leading-5 text-gray-900"
  }, [_vm._v(_vm._s(_vm.name))]), _c('div', {
    staticClass: "text-xs font-normal text-gray-500 leading-4 line-clamp-2 mt-0.5"
  }, [_vm._v(" " + _vm._s(_vm.searchQuery) + " ")])])])]) : _vm._e()], 1) : _vm._e(), _vm.confirmLocation ? _c('div', [_c('div', {
    staticClass: "mt-3 mb-1"
  }, [_c('label', {
    staticClass: "text-base text-gray-800 font-medium mb-0 leading-7"
  }, [_vm._v("Set Access Radius")])]), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "display": "flex",
      "gap": "20px",
      "margin-top": "0px"
    }
  }, [_c('div', {
    staticClass: "flex flex-col w-5/12",
    staticStyle: {
      "flex": "1"
    }
  }, [_c('label', {
    staticClass: "text-xs"
  }, [_vm._v("Reading Radius (50 - 2,000 Meters)")]), _c('div', {
    staticClass: "flex relative justify-start items-center text-center align-middle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.radius,
      expression: "radius",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "border-gray-200 text-xs py-2.5 bg-gray-50 rounded-tl-xl rounded-bl-xl",
    class: {
      'bg-red-200 text-red-500 border-red-400': _vm.validateRadiusLocation
    },
    attrs: {
      "type": "number",
      "min": "0",
      "max": "2000"
    },
    domProps: {
      "value": _vm.radius
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.radius = _vm._n($event.target.value);
      }, _vm.validateRadius],
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('div', {
    staticClass: "h-full text-center align-middle items-center flex px-14 rounded-tr-xl rounded-br-xl border-t border-r border-b bg-gray-100",
    class: {
      'bg-red-200 border-red-400': _vm.validateRadiusLocation
    }
  }, [_c('span', {
    class: {
      ' text-red-500': _vm.validateRadiusLocation
    }
  }, [_vm._v("Meters")])])]), _vm.validateRadiusLocation ? _c('p', {
    staticClass: "text-xs font-normal text-red-500 mt-2"
  }, [_vm._v(" " + _vm._s(_vm.radiusErrorMessage) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "flex flex-col w-full"
  }, [_c('label', {
    staticClass: "text-xs"
  }, [_vm._v("Location Tag")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.locationTag,
      expression: "locationTag"
    }],
    staticClass: "border-gray-200 py-2.5 bg-gray-50 rounded-xl text-xs",
    class: {
      'bg-red-200 placeholder-red-500 border-red-400': _vm.validateLocation
    },
    attrs: {
      "type": "text",
      "placeholder": "Write the location name as a marker (e.g., reading point buildin..."
    },
    domProps: {
      "value": _vm.locationTag
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.locationTag = $event.target.value;
      }
    }
  }), _vm.validateLocation ? _c('p', {
    staticClass: "text-sm font-normal text-red-500 mt-2"
  }, [_vm._v("Must be filled in")]) : _vm._e()])]), _c('div', {
    staticClass: "flex justify-start items-start space-x-3 mt-3"
  }, [_c('Button', {
    staticClass: "flex justify-items-start items-center",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.confirmationSubmitLocation
    }
  }, [_vm._v(" Save Location ")]), _c('Button', {
    staticClass: "flex border justify-items-start items-center",
    attrs: {
      "ovariant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": _vm.handleBackSetLocation
    }
  }, [_vm._v(" Back ")])], 1)]) : _vm._e(), _vm.showMap && !_vm.confirmLocation ? _c('div', {
    staticClass: "flex justify-start items-start space-x-3 mt-3"
  }, [_c('Button', {
    staticClass: "flex justify-items-start items-center",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.confirmLocationData
    }
  }, [_vm._v(" Confirm Location & Continue ")]), _c('Button', {
    staticClass: "flex border justify-items-start items-center",
    attrs: {
      "ovariant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": _vm.handleCloseMap
    }
  }, [_vm._v(" Back ")])], 1) : _vm._e()])]), _c('t-modal', {
    ref: "openModalConfirmationSubmitLocation"
  }, [_c('div', {
    staticClass: "flex-col justify-center text-center"
  }, [_c('label', {
    staticClass: "text-center font-semibold text-sm text-gray-800 tracking-normal"
  }, [_vm._v("Ensure the Location is Correct")]), _c('p', {
    staticClass: "text-gray-500 text-xs font-normal"
  }, [_vm._v("The system will generate a QR Code based on this location. Data cannot be changed once saved.")])]), _c('div', {
    staticClass: "flex justify-center items-center space-x-3"
  }, [_c('Button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function () {
        _this.$refs.openModalConfirmationSubmitLocation.hide();
        _this.$refs.openModalMap.show();
      }
    }
  }, [_c('span', {
    staticClass: "text-xs"
  }, [_vm._v(" Double Check ")])]), _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": _vm.submitLocation
    }
  }, [_c('span', {
    staticClass: "text-xs"
  }, [_vm._v(" Yes, Proceed & Generate QR ")])])], 1)]), _c('t-modal', {
    ref: "modalConfirmationStatus",
    on: {
      "before-close": _vm.onBeforeCloseModalStatus
    }
  }, [_c('div', {
    staticClass: "flex-col justify-center text-center p-0"
  }, [_c('label', {
    staticClass: "text-center font-semibold text-base text-gray-800 tracking-normal"
  }, [_vm._v(" " + _vm._s(_vm.pendingStatusChange == 1 ? 'Active' : 'Deactivate') + " Location ")]), _vm.pendingStatusChange == 1 ? _c('p', {
    staticClass: "text-gray-500 text-sm font-normal mt-0"
  }, [_vm._v(" Users within this location will be able to access onsite content after this location is activated. ")]) : _vm.pendingStatusChange == 9 ? _c('p', {
    staticClass: "text-gray-500 text-sm font-normal mt-0"
  }, [_vm._v(" Users within this location will no longer be able to access onsite content after this location is deactivated. ")]) : _vm._e()]), _c('div', {
    staticClass: "flex justify-center items-center space-x-3 mt-4"
  }, [_vm.pendingStatusChange == 1 ? _c('Button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.confirmStatusChange
    }
  }, [_vm._v(" Activate Location ")]) : _vm.pendingStatusChange == 9 ? _c('Button', {
    staticClass: "bg-red-500 text-white",
    attrs: {
      "color": "red",
      "variant": "default",
      "size": "sm"
    },
    on: {
      "click": _vm.confirmStatusChange
    }
  }, [_vm._v(" Deactivate Location ")]) : _vm._e(), _c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": _vm.cancelStatusChange
    }
  }, [_vm._v(" Cancel ")])], 1)]), _c('t-modal-file', {
    ref: "openDatalocation"
  }, [_vm.savedLocationData ? _c('div', {
    staticClass: "flex flex-col items-center py-6"
  }, [_c('div', {
    staticClass: "text-center mb-6"
  }, [_c('h3', {
    staticClass: "text-base font-semibold text-gray-800"
  }, [_vm._v("Access Location Ready for Use")])]), _c('div', {
    staticClass: "flex-col"
  }, [_c('div', {
    staticClass: "p-3 border"
  }, [_c('img', {
    staticClass: "w-full",
    attrs: {
      "src": _vm.savedLocationData.qr_image,
      "alt": "QR Code"
    }
  })])]), _c('div', {
    staticClass: "bg-gray-50 rounded-xl w-full p-2.5 my-3 flex-col justify-center items-center text-center"
  }, [_c('p', {
    staticClass: "text-base font-semibold m-0"
  }, [_vm._v("Titik Baca " + _vm._s(_vm.savedLocationData.name))]), _c('div', {
    staticClass: "flex justify-center items-center space-x-5"
  }, [_c('p', {
    staticClass: "text-gray-500 text-sm my-0"
  }, [_vm._v("Radius " + _vm._s(_vm.savedLocationData.allowed_radius) + " Meters ")]), _c('p', {
    staticClass: "text-gray-500 text-sm my-0"
  }, [_vm._v(_vm._s(_vm.savedLocationData.latitude) + " " + _vm._s(_vm.savedLocationData.longitude) + " ")])])]), _c('p', {
    staticClass: "text-gray-500 p-2 text-center"
  }, [_vm._v("The coordinates and radius have been saved. Users can only access the SmartPin collection from this area.")]), _c('div', {
    staticClass: "flex space-x-4 w-full justify-center"
  }, [_c('Button', {
    staticClass: "border-t border-b border-l border-r border-blue-500 text-sm text-blue-500 items-center",
    attrs: {
      "ovariant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": _vm.downloadQR
    }
  }, [_vm._v(" Download QR Code ")]), _c('Button', {
    staticClass: "flex justify-items-start items-center",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push(("/smart-pin/location/" + (_vm.savedLocationData.id)));
      }
    }
  }, [_vm._v(" View Detail Location ")])], 1)]) : _vm._e()]), _c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Smartpin'
      }],
      "title": "Access Location"
    }
  }), _c('div', {
    staticClass: "flex justify-between items-end bg-white py-3 px-4"
  }, [_c('div', {
    staticClass: "w-2/6 flex-col"
  }, [_vm._m(0), _c('div', {
    staticClass: "relative"
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-3"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query_search,
      expression: "query_search"
    }],
    staticClass: "p-2.5 pl-5 mb-1 w-full text-sm border rounded-lg",
    attrs: {
      "placeholder": "Search by Tag Location",
      "type": "search"
    },
    domProps: {
      "value": _vm.query_search
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.query_search = $event.target.value;
      }, _vm.onSearch],
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearch.apply(null, arguments);
      }
    }
  })])]), _c('div', {
    staticClass: "flex space-x-4 justify-start items-center"
  }, [_c('Button', {
    staticClass: "flex justify-items-start items-center",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handleOpenModalMap
    }
  }, [_vm._v(" + Add Location ")]), _c('Button', {
    staticClass: "flex border space-x-2 justify-center items-start transition-all duration-300",
    class: _vm.isExporting ? 'bg-gray-100 cursor-not-allowed opacity-60' : 'bg-white hover:bg-gray-50',
    attrs: {
      "disabled": _vm.isExporting,
      "variant": "outlined",
      "color": "alternative",
      "size": "sm"
    },
    on: {
      "click": _vm.exportCSV
    }
  }, [_c('div', {
    staticClass: "text-xs flex justify-center items-center",
    class: _vm.isExporting ? 'text-gray-400' : 'text-gray-700'
  }, [_vm._v(" " + _vm._s(_vm.isExporting ? ("Wait (" + (_vm.exportCountdown) + "s)") : 'Export CSV') + " ")])])], 1)]), _c('div', [_c('Table', {
    staticClass: "shadow-none",
    attrs: {
      "headers": _vm.headers,
      "data": _vm.listLocation,
      "isLoading": _vm.isloadingLocation,
      "withScrollX": false,
      "row-key": ['name', 'allowed_radius', 'active_book_count', 'reading_progress'],
      "withSelectable": false,
      "withPagination": false,
      "withAction": true,
      "withActionsFirst": false,
      "withNumberCol": false
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function (_ref) {
        var row = _ref.row;
        return [_c('div', {
          staticClass: "field-wrapper w-96"
        }, [_c('router-link', {
          staticClass: "p-2.5 rounded-lg w-full text-blue-600 font-medium text-sm underline leading-6 tracking-wide",
          attrs: {
            "to": ("/smart-pin/location/" + (row.id))
          }
        }, [_vm._v(" " + _vm._s(row.name) + " ")])], 1)];
      }
    }, {
      key: "allowed_radius",
      fn: function (_ref2) {
        var row = _ref2.row;
        return [_c('div', {
          staticClass: "field-wrapper"
        }, [_c('span', {
          staticClass: "rounded-lg w-full"
        }, [_vm._v(" " + _vm._s(Number(row.allowed_radius).toLocaleString('id-ID')) + " Meter ")])])];
      }
    }, {
      key: "active_book_count",
      fn: function (_ref3) {
        var row = _ref3.row;
        return [_c('div', {
          staticClass: "field-wrapper"
        }, [_c('span', {
          staticClass: "rounded-lg w-full"
        }, [_vm._v(" " + _vm._s(row.active_book_count) + " Content ")])])];
      }
    }, {
      key: "reading_progress",
      fn: function (_ref4) {
        var row = _ref4.row;
        return [_c('div', {
          staticClass: "field-wrapper"
        }, [_c('span', {
          staticClass: "rounded-lg w-full"
        }, [_vm._v(" " + _vm._s(row.reading_progress) + " % ")])])];
      }
    }, {
      key: "actions",
      fn: function (_ref5) {
        var row = _ref5.row;
        return [_c('div', {
          staticClass: "flex justify-start items-start"
        }, [_c('button', {
          staticClass: "w-12 h-6 button-active-inactive flex justify-start items-start p-0 rounded-full relative transition-colors duration-200 focus:outline-none",
          class: {
            'bg-blue-700': (_vm.uiStatuses[row.id] || row.status) == 1,
            'bg-gray-300': (_vm.uiStatuses[row.id] || row.status) == 9
          },
          attrs: {
            "type": "button"
          },
          on: {
            "click": function ($event) {
              return _vm.openModalConfirmationStatus(row);
            }
          }
        }, [_c('span', {
          staticClass: "w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200",
          class: {
            'translate-x-6': (_vm.uiStatuses[row.id] || row.status) == 1,
            'translate-x-0': (_vm.uiStatuses[row.id] || row.status) == 9
          }
        })])])];
      }
    }])
  }), _vm.totalRows / _vm.perPage > 1 ? _c('div', {
    staticClass: "flex bg-white items-center justify-between ml-0 pt-4 border-t align-middle px-3"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-1"
  }, [_c('label', {
    staticClass: "font-bold text-xl text-gray-700"
  }, [_vm._v("List of Location")])]);
}]

export { render, staticRenderFns }